import { fetchJSON, merge } from 'omni-ui';

const originsByEnv = {
  local: 'https://devshared-objects.api.annalect.com',
  dev: 'https://devshared-objects.api.annalect.com',
  qa: 'https://qashared-objects.api.annalect.com',
  stg: 'https://stgshared-objects.api.annalect.com',
  prod: 'https://shared-objects.api.annalect.com',
};

export default class CentralizedDataAPI {
  constructor(token, env = 'prod') {
    this.token = token;
    this.env = env;

    this.origin = originsByEnv[env];
    this.baseFetchOptions = {
      headers: { Authorization: `Bearer ${token}` },
    };
  }

  request(apiId, apiParams) {
    const url = new URL(`/omni_object/${apiId}/`, this.origin);
    url.search = new URLSearchParams(apiParams);

    return fetchJSON(url, merge(this.baseFetchOptions, { method: 'GET' }));
  }

  getEndpoints() {
    return fetchJSON(`${this.origin}/api_connection/`, this.baseFetchOptions);
  }

  requestProxy(apiId, apiParams, normalizationDef = {}) {
    const url = new URL(`/v2/proxy/freeform/${apiId}`, this.origin);
    url.search = new URLSearchParams(apiParams);

    return fetchJSON(
      url,
      merge(this.baseFetchOptions, {
        method: 'POST',
        body: JSON.stringify({ normalize: normalizationDef }),
      }),
    );
  }

  getSharedObjects(apiParams) {
    const url = new URL('/omni_object/search/', this.origin);
    url.search = new URLSearchParams({
      order_by: 'name',
      length: 'all',
      ...apiParams,
    });
    return fetchJSON(url, this.baseFetchOptions);
  }

  createUserSharedObject(data) {
    return fetchJSON(
      `${this.origin}/omni_object/`,
      merge(this.baseFetchOptions, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    );
  }

  createServiceSharedObject(data, type) {
    const apiConnection =
      type === 'project'
        ? 'f5627c98-0e78-4ada-900c-909fce7e5b16'
        : 'd815be10-deb7-449c-a051-46fcfddfdb0f';
    return fetchJSON(
      `${this.origin}/omni_object/${apiConnection}/single/`,
      merge(this.baseFetchOptions, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    );
  }

  updateServiceSharedObject(data, type) {
    const apiConnection =
      type === 'project'
        ? 'f5627c98-0e78-4ada-900c-909fce7e5b16'
        : 'd815be10-deb7-449c-a051-46fcfddfdb0f';
    return fetchJSON(
      `${this.origin}/omni_object/${apiConnection}/single/`,
      merge(this.baseFetchOptions, {
        method: 'PUT',
        body: JSON.stringify(data),
      }),
    );
  }

  bulkGet(ids) {
    const searchParams = new URLSearchParams(ids.map(id => ['uuid', id]));
    return fetchJSON(
      `${this.origin}/omni_object/bulk?${searchParams.toString()}`,
      this.baseFetchOptions,
    );
  }
}
